export enum TripErrorCodeEnum {
    DRIVER_DELETED = 'DRIVER_DELETED',
    VEHICLE_DELETED = 'VEHICLE_DELETED',
    CARRIER_DELETED = 'CARRIER_DELETED',
}

export enum TripErrorItemNameEnum {
    DRIVER = 'driver',
    VEHICLE = 'vehicle',
}
